// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';

// const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes

// const usePageTracking = () => {
//   const location = useLocation();
//   const [startTime, setStartTime] = useState(new Date());
//   const [pageVisits, setPageVisits] = useState([]);
//   const [sessionId, setSessionId] = useState(Date.now());

//   useEffect(() => {
//     const endTime = new Date();
//     const timeSpent = endTime - startTime;

//     // Record the page visit and time spent
//     setPageVisits((prevVisits) => [
//       ...prevVisits,
//       { sessionId, path: location.pathname, timeSpent, startTime, endTime },
//     ]);

//     // Reset the start time for the next page
//     setStartTime(new Date());

//     const handleActivity = () => {
//       setStartTime(new Date());
//     };

//     // Listen for user activity (mouse movement, keypress)
//     window.addEventListener('mousemove', handleActivity);
//     window.addEventListener('keypress', handleActivity);

//     const timeoutId = setTimeout(() => {
//       setSessionId(Date.now()); // Start a new session
//     }, SESSION_TIMEOUT);

//     // Function to handle beforeunload
//     const handleBeforeUnload = () => {
//       const finalEndTime = new Date();
//       const finalTimeSpent = finalEndTime - startTime;

//       // Record the final page visit before leaving
//       setPageVisits((prevVisits) => [
//         ...prevVisits,
//         { sessionId, path: location.pathname, timeSpent: finalTimeSpent, startTime, endTime: finalEndTime },
//       ]);

//       // Optional: Send data to your API here if needed
//       // await saveDataToApi(pageVisits); // Implement this function as needed
//     };

//     window.addEventListener('beforeunload', handleBeforeUnload);

//     return () => {
//       window.removeEventListener('mousemove', handleActivity);
//       window.removeEventListener('keypress', handleActivity);
//       window.removeEventListener('beforeunload', handleBeforeUnload);
//       clearTimeout(timeoutId);
//     };
//   }, [location, sessionId]);

//   return { pageVisits };
// };

// export default usePageTracking;



import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes
const DEBOUNCE_DELAY = 1000; // 1000 milliseconds

const usePageTracking = () => {
  const location = useLocation();
  const [startTime, setStartTime] = useState(Date.now());
  const [pageVisits, setPageVisits] = useState([]);
  const [sessionId, setSessionId] = useState(Date.now());

  const recordPageVisit = useCallback(() => {
    const endTime = Date.now();
    const timeSpent = endTime - startTime;

    // Record the page visit and time spent
    setPageVisits((prevVisits) => [
      ...prevVisits,
      { sessionId, path: location.pathname, timeSpent, startTime, endTime },
    ]);

    // Reset the start time for the next page
    setStartTime(Date.now());
  }, [location.pathname]);

  useEffect(() => {
    recordPageVisit(); // Record visit when location changes

    const handleActivity = () => {
      setStartTime(Date.now());
    };

    const debouncedHandleActivity = debounce(handleActivity, DEBOUNCE_DELAY);

    // Listen for user activity (mouse movement, keypress)
    window.addEventListener('mousemove', debouncedHandleActivity);
    window.addEventListener('keypress', debouncedHandleActivity);

    const timeoutId = setTimeout(() => {
      setSessionId(Date.now()); // Start a new session
    }, SESSION_TIMEOUT);

    const handleBeforeUnload = () => {
      const finalEndTime = Date.now();
      const finalTimeSpent = finalEndTime - startTime;

      // Record the final page visit before leaving
      setPageVisits((prevVisits) => [
        ...prevVisits,
        { sessionId, path: location.pathname, timeSpent: finalTimeSpent, startTime, endTime: finalEndTime },
      ]);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('mousemove', debouncedHandleActivity);
      window.removeEventListener('keypress', debouncedHandleActivity);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      clearTimeout(timeoutId);
    };
  }, [location.pathname]); // Adjusted dependencies

  // Debounce function
  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  return { pageVisits };
};

export default usePageTracking;
